/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from '../DateRangeSelector';
import { ReactComponent as SearchIcon } from 'Icons/search.svg';

const INTERVALS = [
  { title: 'last week', value: 'week' },
  { title: 'last month', value: 'month' },
  { title: 'last year', value: 'year' }
];

const Toolbar = ({
  selectDateInterval,
  selectedInterval,
  startDate,
  endDate,
  setDateRange,
  searchTerm,
  setSearch
}) => {
  return (
    <div className="toolbar toolbar--style-reports-time">
      <div className="cnt">
        <div className="library__sidebar-search" style={{ width: '100%' }}>
          <SearchIcon />
          <input
            name="text"
            placeholder="search"
            value={searchTerm}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="toolbar__content">
          <nav className="toolbar__navigation">
            <ul>
              {INTERVALS.map(({ title, value }) => (
                <li
                  key={value}
                  className={value === selectedInterval ? 'is-active' : null}
                >
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      selectDateInterval(value);
                    }}
                  >
                    {title}
                  </a>
                </li>
              ))}
              <li className="toolbar__navigation-pull-right">
                <a>
                  <DateRangeSelector
                    {...{ startDate, endDate, setDateRange }}
                  />
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  selectDateInterval: PropTypes.func.isRequired,
  selectedInterval: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  setDateRange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  setSearch: PropTypes.func.isRequired
};

export default Toolbar;
